module.exports = __webpack_public_path__ + "static/contact-cta-22e4171ac02a92d9bb995b40fca68ac9.png";